import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  TplState,
  setHeaderPassedCount,
  setHeaderTotalCount,
  setTplVisibleStep,
  setUpdateTplProgress,
} from '../../../store/tplSlice'
//
//
const TplProgressbar: React.FC<{
  style?: React.CSSProperties
  stepName?: string
}> = ({ style, stepName }) => {
  //
  const dispatch = useAppDispatch()
  //
  const navigate = useNavigate()
  //
  const Pathname = window.location.pathname
  //
  const { progress, filter, checkout, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  //
  //
  //
  const updateProgressBarCallback = useCallback(() => {
    //
    const comparePage = progress.find((p) => p.id === 6) // URL: /tpl-offer
    //
    const forOtherPage = progress.find((p) => p.id === 10) // URL: /tpl-for-other
    //
    const insurerPage = progress.find((p) => p.id === 11) // URL: /tpl-insurer
    //
    //
    if (Pathname && progress && progress.find((p) => p.url === Pathname)) {
      const current = progress.find((p) => p.url === Pathname)
      //
      // update progress status
      if (current && current.id && current.active === false) {
        dispatch(
          setUpdateTplProgress({
            id: current.id,
            title: stepName ?? '',
          }),
        )
      }
      //
      //
      // show & hide tpl offers screen
      if (filter.chooseMethod === 'my-choice' && comparePage && comparePage.isVisible === false) {
        // show step
        dispatch(
          setTplVisibleStep({
            id: 6,
            isVisible: true,
          }),
        )
        //
      } else if (filter.chooseMethod === 'frani-choice' && comparePage && comparePage.isVisible === true) {
        // hide step
        dispatch(
          setTplVisibleStep({
            id: 6,
            isVisible: false,
          }),
        )
      }
      //
      //
      // show tpl forOther screen
      if (checkout.forWho === 'for-other' && forOtherPage && forOtherPage.isVisible === false) {
        return [
          dispatch(
            // show for other page
            setTplVisibleStep({
              id: 10,
              isVisible: true,
            }),
          ),
          // hide for me page
          dispatch(
            setTplVisibleStep({
              id: 9,
              isVisible: false,
            }),
          ),
        ]
        // hide tpl forOther screen
      } else if (checkout.forWho === 'for-me' && forOtherPage && forOtherPage.isVisible === true) {
        return [
          //  hide for other page
          dispatch(
            setTplVisibleStep({
              id: 10,
              isVisible: false,
            }),
          ),
          // show for me page
          dispatch(
            setTplVisibleStep({
              id: 9,
              isVisible: true,
            }),
          ),
        ]
      }
      //
      //
      // show tpl insurer screen
      if (checkout.forWho === 'for-other' && insurerPage && insurerPage.isVisible === false) {
        dispatch(
          setTplVisibleStep({
            id: 11,
            isVisible: true,
          }),
        )
        // hide tpl insurer screen
      } else if (checkout.forWho === 'for-me' && insurerPage && insurerPage.isVisible === true) {
        dispatch(
          setTplVisibleStep({
            id: 11,
            isVisible: false,
          }),
        )
      }
      //
    }
  }, [Pathname, progress, stepName, filter, checkout.forWho, dispatch])
  //
  //
  useEffect(() => {
    updateProgressBarCallback()

    return () => {
      // Cleanup logic if needed
    }
  }, [updateProgressBarCallback]) // Check if this dependency is causing the issue
  //
  //
  const visibledSteps = progress?.filter((x) => x.isVisible === true)
  //
  //
  // update progress counts
  const updateProgressCountCallBack = useCallback(() => {
    //
    const passedStepCount = visibledSteps?.filter((x) => x.passed === true)?.length
    //
    // update progress total count
    if (visibledSteps && screenHeader.totalCount !== visibledSteps.length) {
      dispatch(setHeaderTotalCount(visibledSteps.length))
    }
    //
    // update current page count
    if (passedStepCount && screenHeader.passedCount !== passedStepCount) {
      dispatch(setHeaderPassedCount(passedStepCount))
    }

    //
  }, [dispatch, visibledSteps, screenHeader.totalCount, screenHeader.passedCount])
  //
  //
  // update progress counts
  useEffect(() => {
    updateProgressCountCallBack()

    return () => {}
  }, [updateProgressCountCallBack])
  //
  //
  return (
    <Wrapper style={style}>
      <Content>
        {visibledSteps?.map((item, index) => (
          <Block key={index} $active={item.active} $passed={item.passed}>
            <Ball
              onClick={() => navigate(item.url)}
              style={{
                pointerEvents: item.passed ? 'unset' : 'none',
              }}
            >
              {item.title ? (
                <HoverText>
                  <span>{item.title}</span> <Triangle />
                </HoverText>
              ) : null}
            </Ball>
            <Line />
          </Block>
        ))}
      </Content>
    </Wrapper>
  )
}
//
const Triangle = styled.div`
  width: 0px;
  height: 0px;
  border-width: 9px 8px 8px;
  border-style: solid;
  border-color: ${Colors.white} transparent transparent;
  border-image: initial;
  position: absolute;
  top: -16px;
  transform: rotate(180deg);
`
//
const HoverText = styled.div`
  user-select: none;
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  white-space: nowrap;
  height: 40px;
  border-radius: 4px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  padding-inline: 30px;
  display: none;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${Colors.nevadaGrey};
  z-index: 5;
`
const Line = styled.div`
  height: 2px;
  width: 20px;
  background-color: ${Colors.secondaryGrey};
  user-select: none;
  pointer-events: none;
`
const Ball = styled.div`
  position: relative;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: ${Colors.white};
  box-shadow: inset 0px 0px 0px 2px ${Colors.primaryRed};
  cursor: pointer;
`
const Block = styled.div<{ $active: boolean; $passed: boolean }>`
  display: flex;
  align-items: center;

  /* ball */
  ${Ball} {
    height: ${({ $active }) => ($active ? '16px' : `8px`)};
    width: ${({ $active }) => ($active ? '16px' : `8px`)};

    box-shadow: ${({ $passed, $active }) =>
      $passed || $active
        ? `inset 0px 0px 0px 2px ${Colors.primaryRed}`
        : `inset 0px 0px 0px 2px ${Colors.secondaryGrey}`};

    &:hover {
      height: 16px;
      width: 16px;
      margin-inline: ${({ $active }) => ($active ? '-0px' : `-4px`)};
      /*  */
      ${HoverText} {
        display: flex;
      }
    }
  }

  /* line */
  ${Line} {
    background-color: ${({ $active, $passed }) =>
      $active ? Colors.secondaryGrey : $passed ? Colors.primaryRed : Colors.secondaryGrey};
  }
`

const Wrapper = styled.div`
  /*  */
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${Block} {
    &:last-child {
      ${Line} {
        display: none;
      }
    }
  }
`
//
export default TplProgressbar
